import TaskStatusManager from "./task-status-manager"

const debug = false
// const debug = "GDManagerNewTask"

// new task .... taskData -> api -> response -> new TaskModel(response)
// taskData -> taskModel() (!id) -> validationModel -> model.save() -> api -> response -> update model

export default class GDManagerNewTask {

    static newTask(companyId:ID, projectId:ID, type:string, title:string, params:any = {}, options:any = {}) {

        debug && console.log(debug, 'newTask', companyId, projectId, type, title, params, options)

        const { noRecentAdd } = options
        const status = params.statusId ? gd.session.statuses.get(params.statusId) :
            TaskStatusManager.getTaskStatuses({projectId:projectId, taskTypeId:type}, {orderBySystemStatus: true})[0];

        const request = gd.api.Task.newTask({
            title               : title,
            project             : projectId,
            companyId           : companyId,
            type                : type,

            parentTask          : params.parentTask,
            user                : params.user,
            fromUser            : params.fromUser,
            users               : params.users,
            newProjectUsers     : params.newProjectUsers,
            message             : params.message || params.descriptionTxt,
            messageRTF          : params.messageRTF,
            attachments         : params.attachments,
            customFieldsData    : params.customFieldsData,

            tags                : params.tags,
            priority            : params.priority,
            deadline            : params.deadline,
            estimate            : params.estimate,
            statusId            : status ? status.id : null,
            storyPoints         : params.storyPoints,

            scheduleStatus      : params.scheduleStatus,
            scheduleDate        : params.scheduleDate,
            planningStartDate   : params.planningStartDate,
            planningEndDate     : params.planningEndDate,
            source              : params.source,

            requestFormId       : params.requestFormId,
            checklist           : params.checklist,
        })

        request.done((response:any)=>{
            gd.growl.taskCreated(response.data.newTask.id, response.data.newTask.title, response.data.newTask.shortId)

            if (!noRecentAdd) {
                gd.session.recent.projectsNewTask.projectView(projectId)
                gd.session.recent.tasks.taskView(response.data.newTask) /*add task to recent*/
            }
        })

        return request
    }
}